import React from 'react';
import UsersCardssContain from '../../Componant/Users/UsersCards';

const UserCard = () => {
  return (
    <div className='page-body'>
      <UsersCardssContain />
    </div>
  );
};

export default UserCard;
